import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import * as FontFaceObserver from 'fontfaceobserver'
import * as flatten from 'lodash/flatten'
import * as fontVariables from 'styles/base/font-variables.css'
import { empty } from 'rxjs'

type Font = {
  face: string
  weight: string[]
}

const TIMEOUT = 15000 // ms
const SANS_KEY = 'font_sans_loaded'
const GROTESK_KEY = 'font_grotesk_loaded'
const SANS_CLASSNAME = 'fontSans'
const GROTESK_CLASSNAME = 'fontGrotesk'

const extractFontName = (name: string) => name.replace(/'|"/g, '')

const createFontFacePromise = (font: Font) =>
  font.weight.map((weight) => new FontFaceObserver(font.face, { weight: parseInt(weight, 10) })
    .load(null, TIMEOUT))

const sans = extractFontName(fontVariables.sans)
const serif = extractFontName(fontVariables.serif)
const atlasGrotesk = extractFontName(fontVariables.atlasGrotesk)

const firstPriorityFonts = [
  {
    face: sans,
    weight: [
      fontVariables.regular,
      fontVariables.medium,
      fontVariables.semibold,
    ],
  }, {
    face: serif,
    weight: [
      fontVariables.regular,
      fontVariables.medium,
    ],
  },
]

const secondPriorityFonts = [
  {
    face: atlasGrotesk,
    weight: [
      fontVariables.regular,
      fontVariables.medium,
    ],
  },
]

let firstPriorityFontsPromise: Promise<any> = Promise.resolve()
let secondPriorityFontsPromise: Promise<any> = Promise.resolve()

const fontsEpic: Epic = () => {
  const html = document.documentElement

  if (sessionStorage.getItem(SANS_KEY)) {
    firstPriorityFontsPromise = Promise.resolve()

    if (sessionStorage.getItem(GROTESK_KEY)) {
      secondPriorityFontsPromise = Promise.resolve()
    }
  } else {
    const firstPriorityFontsPromises = flatten(firstPriorityFonts.map(createFontFacePromise))
    const secondPriorityFontsPromises = flatten(secondPriorityFonts.map(createFontFacePromise))
    firstPriorityFontsPromise = Promise.all(firstPriorityFontsPromises)
    secondPriorityFontsPromise = Promise.all(secondPriorityFontsPromises)
  }

  firstPriorityFontsPromise.then(() => {
    html.classList.add(SANS_CLASSNAME)
    sessionStorage.setItem(SANS_KEY, 'true')

    secondPriorityFontsPromise.then(() => {
      html.classList.add(GROTESK_CLASSNAME)
      sessionStorage.setItem(GROTESK_KEY, 'true')
    })
  })

  return empty()
}

export default combineEpics(
  fontsEpic,
)
